import React, { useEffect, useState } from 'react'
import authImage from '../assets/auth-overview.png'
import authImageDark from '../assets/auth-overview-dark.png'

const SlantedWrapper = () => {
  const getIsDark = () =>
    localStorage.getItem('theme') === 'dark' ||
    (!localStorage.getItem('theme') && window.matchMedia('(prefers-color-scheme: dark)').matches)

  const [isDark, setIsDark] = useState(getIsDark)

  useEffect(() => {
    const onStorage = () => setIsDark(getIsDark())
    window.addEventListener('storage', onStorage)
    // Also update on mount and when <html> class changes
    const observer = new MutationObserver(() => setIsDark(getIsDark()))
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] })
    return () => {
      window.removeEventListener('storage', onStorage)
      observer.disconnect()
    }
  }, []);

  return (
    <div className="hidden md:block relative min-h-screen ">
      <img
        src={isDark ? authImageDark : authImage}
        alt="auth-overview"
        className="w-full h-full object-cover"
      />
    </div>
  )
};

export default SlantedWrapper;

